import { ApiError, extractErrorMessage } from "@/api/client";

/**
 * The lines of a refused publish, in full and in the server's words. The server
 * answers 400 with a message listing every problem; the envelope's `errors`
 * carry them one per entry (or the message alone). A message that is not
 * already one of the entries (or their join) leads the list so nothing the server said is lost.
 * Each line is rendered verbatim — the server's text is authoritative.
 */
export function publishRefusalLines(err: unknown): string[] {
  if (err instanceof ApiError) {
    const entries = err.errors.filter((e) => typeof e === "string" && e.trim() !== "");
    // With no envelope message the client builds one by joining the entries;
    // that is a copy, not a lead.
    const isCopy = entries.includes(err.message) || err.message === entries.join("; ");
    const lines = err.message.trim() !== "" && !isCopy ? [err.message, ...entries] : entries;
    if (lines.length > 0) return lines;
  }
  return [extractErrorMessage(err)];
}
